export default "__VITE_ASSET__C8t7SYA8__"